/**
 * Grava os itens de um campo "vários separados por ;" um por vez, NA
 * ORDEM e em sequência (nunca em paralelo: a API tem cerca de taxa e a
 * ordem de gravação é a que a pessoa digitou).
 *
 * Se um falhar, PARA ali. `remaining` devolve o que não entrou — o que
 * falhou e os que vinham depois — pra o campo ficar só com isso e a
 * pessoa não reenviar o que já foi gravado. `added` é o que entrou.
 */
export type SequentialResult = {
  added: string[];
  remaining: string[];
  error: unknown | null;
};

export async function addSequentially(
  items: readonly string[],
  add: (item: string) => Promise<unknown>
): Promise<SequentialResult> {
  const added: string[] = [];
  for (let index = 0; index < items.length; index += 1) {
    try {
      await add(items[index]);
    } catch (error) {
      return { added, remaining: items.slice(index), error };
    }
    added.push(items[index]);
  }
  return { added, remaining: [], error: null };
}

/** O que volta pro campo depois de uma gravação em lote: os que não
 *  entraram, juntos por "; " (vazio quando tudo entrou). */
export function remainingToDraft(remaining: readonly string[]): string {
  return remaining.join('; ');
}
